export class TdoClipboardBaseModel {
  static TYPE_DOCUMENT_DATA = 'DOCUMENT_DATA_LIST';

  static ACTION_CUT = 'CUT';
  static ACTION_COPY = 'COPY';

  type: string;
  action: string = TdoClipboardBaseModel.ACTION_COPY;
  // Abstract to handle different types (e.g. object, array, etc)
  copyData: any;
  parentId: string;
}
